import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const LoginHeaderBlock = styled.div`
    margin-top: calc(100vh * (6 / 812));
`;

export const CloseBtn = styled(Link)`
    position: absolute;
    top: calc(100vh*(17/812));
    right: calc(100vh*(17/812));
    width: calc(100vw*(14/375));
    height: calc(100vh*(14/812));
`;

export const LoginTextBlock = styled.div`
    width: 100%;
`;

export const LoginTitle = styled.h1`
    color: #121212;
    font-size: calc(100vw * (26 / 375));
    line-height: calc(100vw * (38 / 375));
    font-weight: 700;
`;

export const LoginDescription = styled.p`
    color: #121212;
    font-size: calc(100vw * (14 / 375));
    line-height: calc(100vw * (20 / 375));
    font-weight: 500;
    margin-top: calc(100vh * (11 / 812));
`;